import React from 'react';
import {
  ServerError,
  InsufficientPermissions
} from 'modals/RepositoriesModal/repositories-modal.components';
import * as LighthouseService from 'common/services/lighthouse.service';
import { ARTICLE_IDS } from 'common/constants/constants';
import { findAndDeleteSensor } from 'modals/RepositoriesModal/repositories-modal.service';

const RepositoriesModalErrorHandler = ({
  error,
  gitIntegrations,
  sensor_authorization_id,
  deleteSensorAuthorization,
  isOnboarding,
  openReAuthModal
}) => {
  switch (error) {
    case 403:
      return (
        <InsufficientPermissions
          onClick={() =>
            LighthouseService.navigateArticle(
              ARTICLE_IDS.ONBOARDING_TROUBLESHOOT
            )
          }
          findAndDeleteSensor={() =>
            findAndDeleteSensor({
              gitIntegrations,
              sensor_authorization_id,
              deleteSensorAuthorization
            })
          }
          isOnboarding={isOnboarding}
          openReAuthModal={openReAuthModal}
        />
      );
    case 500:
    default:
      return <ServerError />;
  }
};

export default RepositoriesModalErrorHandler;
